import React from 'react';
import styles from './styles/Title.module.scss';

const Title = () => (
  <div className={styles.root}>Authentication with Depth</div>
);

export default Title;
